import React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import styles from "./DetailVerticalList.module.scss";
import Detail from "../Detail/Detail";

export interface DetailVerticalListProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const DefaultDetailVerticalList = (props: DetailVerticalListProps) => {
  const { className, children, ...otherProps } = props;
  return (
    <div className={clsx(styles.detailList, className)} data-deci-detail-vertical-list="true" {...otherProps}>
      {children}
    </div>
  );
};

const DetailVerticalList = createPluggable<DetailVerticalListProps>("deci.detailVerticalList", DefaultDetailVerticalList);

export default Object.assign(DetailVerticalList, {
  Item: Detail,
  Icon: Detail.Icon,
  Title: Detail.Title,
  Content: Detail.Content,
});
